module.exports = __webpack_public_path__ + "media/components/assets/icons/close_btn_24_moreinfo-96babcff26266081b5b8baba7b1b0043.svg";